import PropTypes from 'prop-types';
import React, { Component } from 'react';
import format from 'date-fns/format';

const tosLastUpdated = format(process.env.TOS_LAST_UPDATED, 'MMM Do YYYY');

const styles = {
  container: {
    padding: 10,
    textAlign: 'justify',
    fontFamily: 'Raleway',
  },
  link: {
    textDecoration: 'underline',
  },
  listNumeric: {
    fontWeight: '600',
    marginBottom: 20,
  },
  listNumericItem: {
    marginBottom: 20,
  },
  list: {
    fontWeight: '600',
    listStyle: 'disc',
    marginBottom: 20,
  },
  card: {
    padding: 5,
    overflow: 'auto',
    margin: '-10px',
  },
  p: {
    fontSize: 12,
    textAlign: 'justify',
  },
};

// eslint-disable-next-line react/prefer-stateless-function
export default class TermsOfService extends Component {
  static propTypes = {
    style: PropTypes.object,
  };

  render() {
    const { style } = this.props;
    const copyrightEmailLink = (
      <a
        style={styles.link}
        href='mailto:copyright@ripplestreet.com'
      >
        copyright@ripplestreet.com
      </a>
    );
    const helpEmailLink = (
      <a
        style={styles.link}
        href='mailto:copyright@ripplestreet.com'
      >
        copyright@ripplestreet.com
      </a>
    );
    const legalEmailLink = (
      <a
        style={styles.link}
        href='mailto:legal@ripplestreet.com'
      >
        legal@ripplestreet.com
      </a>
    );
    const privacyPolicyLink = (
      <a
        style={styles.link}
        href={`${process.env.APP_URL}/privacy-policy`}
      >
        Privacy Policy
      </a>
    );
    const ftcTestimonialGuideLink = (
      <a
        style={styles.link}
        href='https://www.ftc.gov/sites/default/files/attachments/press-releases/ftc-publishes-final-guides-governing-endorsements-testimonials/091005revisedendorsementguides.pdf'
      >
        FTC&apos;s Guides Concerning the Use of Endorsements and Testimonials in Advertising
      </a>
    );
    const ftcAdvertisingDisclosureLink = (
      <a
        style={styles.link}
        href='https://www.ftc.gov/sites/default/files/attachments/press-releases/ftc-staff-revises-online-advertising-disclosure-guidelines/130312dotcomdisclosures.pdf'
      >
        FTC&apos;s .com Disclosures
      </a>
    );
    return (
      <div style={{ ...(style || {}), ...styles.container }}>
        <div style={styles.card}>
          <p>
            Updated effective {tosLastUpdated}.
          </p>
          <p>
            Welcome to www.ripplestreet.com (this &ldquo;Website&rdquo;). This Website is operated by House Party, Inc.,
            d/b/a Ripple Street, a Delaware corporation (&ldquo;Ripple
            Street,&rdquo; &ldquo;we,&rdquo; &ldquo;our,&rdquo;or &ldquo;us&rdquo;). These Terms of Service
            (these &ldquo;Terms of Service&rdquo;) govern your use of this Website.
          </p>
          <p>
            <strong>Your Agreement to Be Bound By These Terms of Service</strong>
          </p>
          <p>
            Please read these Terms of Service carefully before browsing or using this Website. By browsing or using
            this Website, you are agreeing to be bound by these Terms of Service. If you do not AGREE to be bound by
            these Terms of Service, you MAY NOT use this Website.
          </p>
          <p>
            <strong>Changes to These Terms of Service</strong>
          </p>
          <p>
            As we add new features and functionality to this Website, we may need to update or revise these Terms of
            Service. We reserve the right to do so, at any time and without prior notice, by posting the revised version
            on this Website. These changes will be effective as of the date we post the revised version on this Website.
            Your use of this Website following any such change constitutes your consent to the new Terms of Service
            posted on this Website. For this reason, it is important to review these Terms of Service regularly. If we
            modify these Terms of Service, we will provide a notice at the top of these Terms of Service for at least 30
            days after the new effective date.
          </p>
          <p>
            You may access the current version of these Terms of Service at any time by clicking on the link
            marked &ldquo;Terms of Service&rdquo; at the bottom of each page of this Website. For your convenience, we
            post the effective date of these Terms of Service at the top of this page, so that you can see at a glance
            whether these Terms of Service have changed since your last visit.
          </p>
          <p>
            <strong>Our Online Privacy Policy</strong>
          </p>
          <p>
            Ripple Street is committed to providing the information you need to make informed choices about the way you
            use this Website and the personal information you share with us. Please review our
            Online {privacyPolicyLink} (a link to which is posted on every page of this Website) to learn what personal
            information we collect through this Website, how we use and share the personal information we collect, and
            some of the steps we take to protect your privacy. Our Online {privacyPolicyLink} is part of these Terms of
            Service. By agreeing to these Terms of Service, you are also consenting to the collection, use and
            disclosure of your personal information in accordance with our Online {privacyPolicyLink}.
          </p>
          <p>
            <strong>Other Agreements</strong>
          </p>
          <p>
            <strong>Click-Through Agreements.</strong> When you sign up to use a special feature or password-protected
            area of this Website, you may be asked to agree to special terms governing your use of the special feature
            or password-protected area. In such cases, you will be asked to expressly consent to the special terms, for
            example, by checking a box or clicking on a button marked &ldquo;I agree.&rdquo; This type of agreement is
            known as a &ldquo;click-through&rdquo;agreement. If any of the terms of the click-through agreement are
            different than the terms of these Terms of Service, the terms of the click-through agreement will supplement
            or amend these Terms of Service, but only with respect to the matters governed by the &ldquo;click-through
            agreement.&rdquo;
          </p>
          <p>
            <strong>Release, Waiver of Liability and Indemnity Agreement.</strong> When you apply to host a Ripple
            Street event or use this Website to accept an invitation to attend a Ripple Street event, you will be asked
            to agree to our Release, Waiver of Liability and Indemnity Agreement (the &ldquo;Release&rdquo;). The terms
            of the Release supplement and amend this {privacyPolicyLink}, but only with respect to the subject matter of
            the Release. Please read the Release carefully. If you do not agree to the terms of the Release, you may not
            host or attend a Ripple Street event.
          </p>
          <p>
            <strong>Registration</strong>. Only visitors who complete our registration process (&ldquo;Registered
            Users&rdquo;) may post User Generated Content and use other features and functionality of this Website.
          </p>
          <p>
            <strong>Age and Location Restrictions.</strong>You must be at least 18 years of age and a U.S. or Canadian
            resident to become a Registered User. By registering on this Website, you represent and warrant to us that
            you are at least 18 years old, a resident of the United States or Canada and have read, accept and agree to
            be bound by these Terms of Service. If we learn that you have violated any of these age restrictions or that
            the collection of your personal information was not lawful under the circumstances, your registration will
            be revoked and we will delete your Account Information and User Generated Content from this Website.
          </p>
          <p>
            <strong>Age Verification.</strong> Registration for and attending certain activities or events, such as
            product demonstrations, parties, and sampling, educational and informational activities
            (collectively &ldquo;Activities&rdquo;) may require you to submit to age and/or identity verification. In
            the event you register for any such Activities, you hereby: (a) agree to provide to Ripple Street and/or its
            third party service providers true and accurate identification documentation and related information
            requested by Ripple Street to verify your age and/or identity; and (b) authorize Ripple Street to verify
            your age, identity and other personally identifiable information pertinent to your participation in the
            Activities directly or through the use of third parties, including the use of third party databases that
            contain driver&apos;s license, social security, financial and other personally identifiable information.
            Account Information and Public Profile. When you register on this Website, you will be required to provide
            certain personal information to us. This information becomes part of your Ripple Street account information
            (your&ldquo;Account Information&rdquo;) and some of this information becomes part of your&ldquo;Public
            Profile.&rdquo; Your &ldquo;Account Information&rdquo; includes your personal details (such as your name,
            contact information, shipping address, screen name and password), your photograph, and your contact
            preferences. Your Account Information is password protected. Your Public Profile is the information that
            others will see if they click on your screen name or any User Generated Content you have posted. Your Public
            Profile includes your screen name, age, gender and photograph (unless you choose to use an icon instead of a
            photograph) and the number of photos, videos, and blog posts you have posted.
          </p>
          <p>
            <strong>Account Information Must Be Accurate.</strong> By registering on this Website, you represent and
            warrant to us that the information you have provided about yourself is true, accurate and complete. Further,
            you agree to keep your information true, accurate and complete by logging onto this Website and updating
            your Account Information promptly if your personal details change.
          </p>
          <p>
            <strong>&ldquo;Facebook Connect&rdquo; and Compatible Services.</strong> During the registration process,
            you will be provided the opportunity to shorten your registration process by automatically providing
            personal data you have already provided during your registration for Facebook or other websites, for
            example, by using Facebook Connect or similar services (each, a &ldquo;Compatible Service&rdquo;). However,
            you may still be asked to enter additional information about yourself on this Website, as we may require
            information that was not required during your registration for the Compatible Service.
          </p>
          <p>
            <strong>Your Screen Name and Password.</strong> You must choose a screen name and password when you
            register. You will need to sign in using your screen name and password in order to use certain features of
            this Website. For example, you cannot post User Generated Content without first signing in.
          </p>
          <p>
            You may not use the screen name or password of any other person to access this Website.
          </p>
          <p>
            You are responsible for maintaining the confidentiality of your password and may not let any other person
            use it to access this Website. You will be solely responsible for the activities of anyone accessing this
            Website using a password assigned to you, even if the activities were not, in fact, authorized by you. You
            must notify Ripple Street immediately of any unauthorized use of your screen name or password. Email us
            at {legalEmailLink}. In addition, if you believe or suspect your password has been compromised, you must
            promptly access your &ldquo;profile page&rdquo; and change your password.
          </p>
          <p>
            <strong>Revocation of Registration.</strong> Ripple Street has the right to revoke your registration and
            delete your Account Information, Public Profile, and your User Generated Content, for any reason at any
            time, in our sole discretion. If we do so, you will no longer be able to access the password protected areas
            or functionality of this Website.
          </p>
          <p>
            <strong>Your Feedback</strong>. We welcome your comments, feedback, suggestions, and other communications
            regarding Ripple Street events, this Website, and other aspects of our business, including your ideas for
            new features and other ways that we can make this Website more fun and more useful to you
            (collectively, &ldquo;Feedback&rdquo;). Note, however, that any Feedback you provide to us through this
            Website shall be and remain the exclusive property of Ripple Street. Your submission of Feedback will
            constitute an assignment to us of all worldwide rights, title and interests in your Feedback, including all
            copyrights and other intellectual property rights in your Feedback. We will be entitled to reduce to
            practice, exploit, make, use, copy, disclose, display or perform publicly, distribute, improve and modify
            any Feedback you submit for any purpose whatsoever, without restriction and without compensating you in any
            way. For this reason, we ask that you not send us any Feedback that you do not wish to assign to us.
          </p>
          <p>
            <strong>User Generated Content</strong>
          </p>
          <p>
            <strong>What is &ldquo;User Generated Content&rdquo;?</strong> If you are a Registered User, you will be
            able to upload, transmit through or otherwise make available (&ldquo;post&rdquo;)&ldquo;User Generated
            Content&rdquo; on or through this Website. As used in these Terms of Service, &ldquo;User Generated
            Content&rdquo; means all of the text, photographs, images, illustrations, graphics, sounds, video and
            audio-video clips, and other content you post on or through this Website, except your Feedback and any part
            of your Account Information that is not included in your Public Profile. User Generated Content includes
            anything you post on a party page and the content of any emails or other communications you send through
            this Website, such as invitations to a party or follow-up communications.
          </p>
          <p>
            <strong>License to Use Your User Generated Content.</strong> By posting User Generated Content on or through
            this Website, you are granting Ripple Street a perpetual, worldwide, royalty-free license to use, exploit,
            copy, perform and display publicly (including, in the case of sound recordings, to perform publicly and in
            digital audio transmission), distribute, and prepare derivative works based on your User Generated Content,
            in whole or in part, in connection with (a) the promotion and operation of this Website; Ripple Street
            events; Ripple Street&apos;s clients; the Ripple Street business and brand; the use on Ripple Street&apos;s
            Facebook, Twitter, You Tube, Instagram, Pinterest, Vine, Meerkat, Periscope, and Google and other pages,
            including use in promoted posts or any other form of Facebook ads as well as display ads, including but not
            limited to banner ads and on websites in connection with Ripple Street and its clients; the products,
            services and brands of the company that sponsored the event to which your User Generated Content relates
            (the &ldquo;Sponsor&rdquo;); and the products, services and brands of the Sponsor&apos;s affiliates, and (b)
            in any other way expressly permitted under these Terms of Service or our {privacyPolicyLink}. Postings on
            Facebook, YouTube and other third party sites are subject to their respective terms and conditions as well
            as Ripple Street&apos;s.
          </p>
          <p>
            The license you grant to us is non-exclusive (meaning you are free to license your User Generated Content to
            anyone else in addition to us), fully-paid and royalty-free (meaning that neither we nor any downstream
            users are required to pay you for the use of your User Generated Content), fully sublicensable (so that, for
            example, we are able to sublicense your User Generated Content to our Sponsors and to visitors to this
            Website, who may access, use, transmit, stream, download, print and further sublicense your User Generated
            Content); worldwide (because the Internet and this Website are global in reach), and fully assignable (so
            that, for example, if we sell our business, reorganize, or merge with another business, the new owner may
            continue to operate this Website under the Ripple Street brand or another name). This license may be
            exercised by Ripple Street and its sublicensees in any format, media or technology, now known or hereafter
            developed. Notwithstanding anything to the contrary in these Terms of Service, to the fullest extent
            permitted by law, you waive any and all claims you may now or later have in any jurisdiction to
            so-called &ldquo;moral rights&rdquo; with respect to the User Generated Content, and all rights of privacy
            or publicity in, or approval rights with respect to, your User Generated Content.
          </p>
          <p>
            Without limiting the generality of the foregoing grant of license, by posting User Generated Content on or
            through this Website, you are granting Ripple Street (and downstream users) permission (a) to display
            advertisements in connection with User Generated Content and to use User Generated Content for advertising
            and promotional purposes without compensating you in anyway; and (b) to make your User Generated Content
            available to the general public through this Website and third-party websites, through RSS feeds, and in any
            other manner, in or using any format or media or technology, now known or hereafter developed, without
            compensating you in any way.
          </p>
          <p>
            By posting User Generated Content on or through this Website, you acknowledge and agree that (a) Ripple
            Street has no obligation to post, maintain, use or respond to User Generated Content submitted to this
            Website; (b) the provision of User Generated Content to Ripple Street in no way imposes any other obligation
            on Ripple Street, whether of confidentiality, attribution, or otherwise, and Ripple Street shall not be
            liable for any claims arising out of or relating to any use, modification, distribution, reproduction,
            display or disclosure of any User Generated Content; (c) you hereby waive any and all claims (including,
            without limitation, claims based upon invasion of privacy, defamation, false light, or right of publicity)
            arising out of any use, alteration, distortion or illusionary effect, or use in any manner permitted by this
            Agreement of your image/likeness, arising out of the posting of User Generated Content containing your
            photograph or other image to this Website; (d) no fees, royalties or any other monies
            (&ldquo;Royalties&rdquo;) will be owed to any person by reason of any User Generated Content, and if any
            Royalties are owed, you will pay all such Royalties; and (e) User Generated Content submitted to this
            Website may be subject to size and usage limitations, other limitations and restrictions, and the terms of
            this Agreement, and you are solely responsible for adhering to such requirements with regard to any User
            Generated Content you provide to this Website.
          </p>
          <p>
            By posting User Generated Content on or through this Website, you agree that Ripple Street may access, copy,
            preserve, and disclose your User Generated Content if required to do so by law or in a good faith belief
            that such access preservation or disclosure is reasonably necessary to: (a) comply with legal process or
            applicable law; (b) enforce these Terms of Service; (c) respond to claims that any User Generated Content
            violates the rights of third-parties; (d) respond to your requests for assistance; (e) prevent or
            investigate a crime; or (f) protect the rights, property, or personal safety of Ripple Street or others.
          </p>
          <p>
            By posting User Generated Content on or through this Website, you are granting Ripple Street (and downstream
            users) and distributors, permission (with no obligation) to use your screen name, photograph, and other
            elements of your Public Profile in connection with your User Generated Content.
          </p>
          <p>
            <strong>
              DO NOT POST USER GENERATED CONTENT if you do not want it to be used or made available to the general
              public as set forth in these Terms of Service. If you do not want your photograph to be made available to
              the general public, DO NOT UPLOAD A PHOTOGRAPH to your profile page on this Website. Instead, select an
              icon to represent you.
            </strong>
          </p>
          <p>
            <strong>
              For increased security, we encourage you to not include any personal information about yourself or others
              in interactive areas (posting areas, chat areas, etc.), such as name, phone number, email or street
              address. You should always use a screen name or other alias (other than your real name) to identify
              yourself in any public or interactive areas.
            </strong>
          </p>
          <p>
            <strong>Termination of Licenses Granted to Ripple Street.</strong> The licenses granted above will
            automatically terminate with respect to Ripple Street&apos;s future uses of User Generated Content within a
            commercially reasonable time after you remove (or ask us to remove) such User Generated Content from this
            Website. However, to the extent we have already exercised any of the foregoing license rights with respect
            to the removed User Generated Content, such licenses will not be deemed revoked as to the prior uses. In
            addition, such licenses will not be deemed revoked as to any User Generated Content that has been
            transmitted to other Websites, persons or media.
          </p>
          <p>
            <strong>Your Warranties With Respect to User Generated Content.</strong> You acknowledge that the above
            grant of license is supported by good, valuable, and sufficient consideration. By posting User Generated
            Content, you represent and warrant that: (a) you own your User Generated Content or otherwise have the right
            to grant the license set forth in these Terms of Service; (b) the posting of your User Generated Content on
            or through this Website does not violate the copyrights, trademark rights, privacy rights, publicity rights,
            trade secret rights, confidentiality rights, contract rights or any other rights of any individual, living
            or deceased, or any legal entity; and (c) you have read and understood and your User Generated Content fully
            complies with these Terms of Service and applicable laws.
          </p>
          <p>
            <strong>Ripple Street Does Not Claim Ownership of User Generated Content.</strong> Ripple Street does not
            assert any ownership over User Generated Content (except the within license); rather, as between us and you,
            subject to the rights granted to us in these Terms of Service, you retain full ownership of all of User
            Generated Content and any intellectual property rights or other proprietary rights associated with User
            Generated Content.
          </p>
          <p>
            You are solely responsible for protecting your intellectual property rights in your User Generated Content.
            Ripple Street cannot and does not assume responsibility for controlling, monitoring, or enforcing your
            intellectual property rights.
          </p>
          <p>
            <strong>You Are Legally Responsible for Your User Generated Content.</strong> Failure to comply with these
            Terms of Service may expose you to liability to Ripple Street and liability to individuals or legal entities
            whose copyrights or other rights have been violated. For this reason, you should review these Terms of
            Service regularly and contact us first if you have any questions about the suitability of materials you wish
            to post. Remember, once User Generated Content is posted it may quickly be transferred to other websites and
            media that we do not control, and it may be impossible to recover or delete.
          </p>
          <p>
            <strong>Restrictions on User Generated Content.</strong> You may not post any User Generated Content on or
            through this Website that:
          </p>
          <ul style={styles.list}>
            <li>
              is protected by copyright, trademark, privacy or publicity rights, trade secret rights, confidentiality
              rights, contract rights, or other rights without the express permission of the owner of the respective
              right;
            </li>
            <li>
              is harmful; hateful; threatening; abusive; harassing; defamatory or libelous; sexually explicit, vulgar,
              lewd, obscene, or pornographic; offensive; inappropriate; or inflammatory;
            </li>
            <li>
              you know (or reasonably should know) is false, deceptive or misleading;
            </li>
            <li>
              contains software viruses, Trojan Horses or any other computer code, files or programs designed to
              interrupt, destroy or limit the functionality of any computer software or hardware or telecommunications
              equipment;
            </li>
            <li>
              contains any private or sensitive information of any third party, particularly information that could be
              used for identity theft purposes, including addresses, phone numbers, email addresses, Social Security
              numbers, birth dates, and credit card numbers;
            </li>
            <li>
              contains any visible Trademarks except those of Ripple Street or the Sponsor of the party or that are
              included on materials provided by Ripple Street or the Sponsor of the party;
            </li>
            <li>
              contains the image, name, or likeness of any individual other than the Registered User, unless the
              Registered User has first obtained the individual&apos;s permission;
            </li>
            <li>
              contains the image, name or likeness of any child under the age of 14, unless you are the parent or legal
              guardian of the child or have obtained the permission of the child&apos;s parent or legal guardian;
            </li>
            <li>
              involves the transmission of &ldquo;junk mail,&rdquo; &ldquo;chain letters,&rdquo; &ldquo;pyramid
              schemes,&rdquo; &ldquo;Ponzi schemes&rdquo; or similar material, constitutes unsolicited mass mailing
              or &ldquo;spamming,&rdquo;or otherwise violates the federal CAN-SPAM law or any state spam laws;
            </li>
            <li>
              contains restricted or password-only access pages, or hidden pages or images (those not linked to or from
              another accessible page);
            </li>
            <li>
              displays pornographic or sexually explicit material of any kind;
            </li>
            <li>
              is likely to violate (in whole or part) the acceptable use policies of our Internet Service Providers
              (ISPs) or other suppliers;
            </li>
            <li>
              links to materials or other content, directly or indirectly, to which the Registered User posting such
              material does not have a right to link to or which competes in any manner with this Website or Ripple
              Street;
            </li>
            <li>
              encourages others to violate these Terms of Service; or
            </li>
            <li>
              violates any applicable local, state, national, or international law.
            </li>
          </ul>
          <p>
            Please notify Ripple Street immediately at {legalEmailLink} of any User Generated Content that you believe
            violates these Terms of Service.
          </p>
          <p>
            <strong>Communications and Other Material Posted by You.</strong> You are responsible for the content of
            your communications, messages and posts, and its consequences. We reserve the right to terminate your
            registration if we become aware, at our sole discretion, that you are violating any of the guidelines set
            forth in this agreement and {privacyPolicyLink}.
          </p>
          <p>
            You are responsible for the content of your communications, messages and posts, and its consequences. We
            reserve the right to terminate your registration if we become aware, at our sole discretion, that you are
            violating any of the guidelines set forth in this agreement and {privacyPolicyLink}.
          </p>
          <p>
            By participating in this website, you understand and agree not to post or transmit any material that, in our
            judgment, is defamatory, abusive, obscene, threatening or unlawful in any way, or any material that
            infringes on the rights of others or contains any virus or other computer programming routine which may
            interfere with or damage the site or otherwise interrupt on the ability of others to use or enjoy the same.
            We reserve the right to delete, move or edit any postings that come to our attention that we consider
            unacceptable or inappropriate, whether for legal or for any other reason. Furthermore, we reserve the right
            to deny access to anyone who we believe, in our sole discretion, has in any way breached these Terms or
            where we reasonably believe a user does not comply with any relevant age restrictions on the site. Should
            members want to discuss, review, blog, make videos and/or write on social media about products or brands
            they test complimentary through Ripple Street, members agree to properly disclose that they received the
            product complimentary through Ripple Street and follow all FTC guidelines and regulations.
          </p>
          <p>
            Members who participate in House Party and Chatterbox events and other Ripple Street programs also agree not
            to post or transmit any material on other websites and social media sites, blogs and videos that, in our
            judgment, is defamatory, abusive, obscene, threatening or unlawful in any way. All members agree not to use
            inappropriate language and phrases when on the Ripple Street website and when participating and
            communicating about Ripple Street events and Sponsors on outside websites, blogs, videos and other
            platforms.
          </p>
          <p>
            <strong>Disclosure Policy</strong>
          </p>
          <p>
            Ripple Street contains product reviews by its members and others, which are given in response to receipt of
            free products straight from the manufacturers. Neither Ripple Street or its members are instructed, coached,
            coerced, paid, or compensated in any fashion in exchange for reviews of manufacturer&apos;s products. All
            reviews are provided voluntary, and published for the informational purposes. All members are required to
            disclose their receipt of free products whenever they make any public statements about them, either through
            Ripple Street or independently. The hashtag &ldquo;#sponsored&rdquo; must be included clearly and
            conspicuously in member-published posts when participating in and communicating about Ripple Street events
            and product sponsors in content created on outside websites, social media sites, blogs, videos and other
            platforms.
          </p>
          <p>
            Our mission is to provide the best, most authentic product feedback available anywhere on the web, and it is
            of the utmost importance to us that we remain as transparent as possible. Should you have any questions
            regarding our practices, we may be contacted at: {helpEmailLink}
          </p>
          <p>
            <strong>Disclosure Requirement</strong>
          </p>
          <p>
            The Federal Trade Commission requires testing program participants to disclose that they have received
            products for complimentary testing purposes in all reviews, social media posts, videos, blogs and online
            content (as outlined in the {ftcTestimonialGuideLink} (&ldquo;FTC Endorsement Guides&rdquo;) and
            the {ftcAdvertisingDisclosureLink}. Please note that failure to abide by these rules will result in
            suspension from Ripple Street. As a means of making compliance to these Federal Trade Commission Guidelines
            more understandable, we&apos;ve set out the following guidelines to help ensure that you&apos;re in
            compliance:
          </p>
          <br />
          <p>
            Writing a blog post or review online?
            <br />
            Copy &amp; paste this line at the bottom: &ldquo;I received these products complimentary from Ripple Street
            for testing purposes.&rdquo;
          </p>
          <br />
          <p>
            Filming a video?
            <br />
            Be sure to script the following into your video: &ldquo;I received these products complimentary from Ripple
            Street for testing purposes.&rdquo; It&apos;s also helpful to copy &amp; paste this text in
            the &ldquo;About&rdquo;section of your video.
          </p>
          <br />
          <p>
            Posting on social media sites like X, Facebook, Instagram or Pinterest?
            <br />
            Make sure you attach the appropriate event hashtag as well as the &ldquo;#sponsored&rdquo;hashtag clearly
            and conspicuously in the text of your published social posting.
          </p>
          <p>
            * Always Remember: If you&apos;re unsure on how to properly disclose, you can always reach out to the Ripple
            Street team for help by emailing {helpEmailLink}.
          </p>
          <p>
            <strong>Quality and Review of Content.</strong> You acknowledge and agree that Ripple Street does not and
            shall not have any obligation to review User Generated Content, and therefore we do not guarantee the
            accuracy, integrity or quality of User Generated Content and we cannot assure you that harmful, inaccurate,
            deceptive, offensive, threatening, defamatory, unlawful or otherwise objectionable User Generated Content
            will not appear on this Website. You acknowledge and agree, however, that we have the absolute right to
            monitor all User Generated Content in our sole discretion. In addition, you acknowledge and agree that we
            have the right to alter, edit or remove any User Generated Content, in whole or in part, for any reason or
            for no reason.
          </p>
          <p>
            <strong>Your Use of User Generated Content Posted by Others.</strong> You may not use, copy, reproduce,
            distribute, publish, display or perform, create derivative works of, transmit, sell, or in any way exploit
            any of the User Generated Content posted by others in a manner that violates applicable laws or the
            copyrights, trademark rights, privacy rights, publicity rights, trade secret rights, confidentiality rights,
            contract rights or any other rights of any individual or legal entity.
          </p>
          <p>
            <strong>RSS Feeds.</strong> We offer RSS feeds of certain User Generated Content on this Website. You are
            granted a limited, revocable license to incorporate this Website&apos;s RSS feeds into your own website,
            mobile-device or other digital platform, solely for non-commercial purposes. You are prohibited from
            sublicensing, reproducing, reselling, modifying, or otherwise using or distributing the Content within the
            RSS feed except as expressly licensed herein. If you wish to obtain a license to use any Content within one
            of our RSS feeds or otherwise for any purpose not expressly authorized by these Terms of Service, please
            contact Ripple Street at {legalEmailLink}. You understand and agree that we may grant our Sponsors, with
            whom we have entered a separate agreement, a license to use the RSS feeds (including all User Generated
            Content therein) in a commercial manner in order to promote their products and services.
          </p>
          <p>
            <strong>Removal of User Generated Content</strong>
          </p>
          <p>
            <strong>In General.</strong> If you would like us to remove any User Generated Content from this Website for
            any reason, please notify us at {copyrightEmailLink}. While we do not have any obligation to remove User
            Generated Content merely because of a removal request, Ripple Street will review all such requests and will
            remove User Generated Content that we determine should be removed, in our sole discretion and in accordance
            with our {privacyPolicyLink} and applicable law. If you are requesting removal of User Generated Content due
            to a violation of your copyrights, please follow the procedure described in the &ldquo;Violation of
            Copyrights/Copyright Agent&rdquo; paragraph below.
          </p>
          <p>
            <strong>Violation of Copyrights/Copyright Agent.</strong> The Digital Millennium Copyright Act of 1998
            (the&ldquo;DMCA&rdquo;) provides recourse for copyright owners who believe that material appearing on the
            Internet infringes their rights under U.S. copyright law. If you believe that your work has been copied and
            posted on this Website in a way that constitutes copyright infringement, please provide our copyright agent
            with the following information: an electronic or physical signature of the copyright owner or of the person
            authorized to act on behalf of the owner of the copyright interest; a description of the copyrighted work
            that you claim has been infringed; a description of where the material that you claim is infringing is
            located on this Website (including the URL, title and/or item number if applicable, or other identifying
            characteristics); your name, address, telephone number, and e-mail address, and, if you are not the owner of
            the copyright, the name of the owner; a written statement by you that you have a good faith belief that the
            disputed use is not authorized by the copyright owner, its agent, or the law; a statement by you, made under
            penalty of perjury, that the above information in your notice is accurate and that you are the copyright
            owner or authorized to act on the copyright owner&apos;s behalf. Any notification by a copyright owner or a
            person authorized to act on its behalf that fails to comply with the requirements of the DMCA shall not be
            considered sufficient notice and shall not be deemed to confer upon Ripple Street actual knowledge of facts
            or circumstances from which infringing material or acts are evident. Ripple Street&apos;s copyright agent
            for notice of claims of copyright infringement can be reached as follows:
          </p>
          <p>
            Name: House Party, d/b/a Ripple Street <br />
            Telephone: 914-591-4550 Fax: 914-591-4561
          </p>
          <p>
            Email: {copyrightEmailLink}
          </p>
          <p>
            <strong>Auto-Shipment and Opt-Out Availability</strong>
          </p>
          <p>
            By registering to be a Ripple Street member, you accept that we reserve the right to ship a package(s) to
            you at our discretion. However, you will be provided, with at least 48 hours advance email notification in
            the event you are selected to receive a shipment. You may opt-out of receiving any such shipment should you
            choose not to participate by responding to the email notification within 72 hours.
          </p>
          <p>
            <strong>Rules of Use</strong>
          </p>
          <p>
            The following additional rules apply to your use of this Website; you may not:
          </p>
          <ul style={styles.list}>
            <li>
              attempt to access areas or features of this Website or any Content for which you do not have the proper
              authorization;
            </li>
            <li>
              impersonate any person or entity, or falsely state or otherwise misrepresent yourself, your age, or your
              affiliation with any person or entity;
            </li>
            <li>
              use this Website in a manner that violates any laws or regulations;
            </li>
            <li>
              use this Website to solicit money, goods or services for private gain;
            </li>
            <li>
              use this Website to solicit money, goods or services for any charitable purpose, except in connection with
              your participation in a Ripple Street event that has a charitable purpose;
            </li>
            <li>
              use this Website to promote political views or candidates;
            </li>
            <li>
              use thus Website to transmit chain letters or junk email;
            </li>
            <li>
              use this Website to further or promote any criminal or illegal activity or to provide instructional
              information about illegal activities;
            </li>
            <li>
              use this Website in a manner that interferes with, disables, disrupts, impairs, or creates an undue burden
              on the networks or services that support this Website;
            </li>
            <li>
              use this Website to harvest or collect email addresses or other contact information of other users by
              electronic or other means for the purposes of sending unsolicited emails or other unsolicited
              communications;
            </li>
            <li>
              use this Website in a manner that, in our sole discretion, restricts or inhibits any other user from using
              or enjoying this Website or a Ripple Street event
            </li>
          </ul>
          <p>
            <strong>Code of Conduct</strong>
          </p>
          <ol style={styles.listNumeric}>
            <li style={styles.listNumericItem}>
              <p>
                <strong>Disclosure</strong>
              </p>
              <p>
                When you post comments or content about a company, its products or services, you should clearly and
                conspicuously disclose the nature of your relationship. Tell people that you&apos;re a Ripple Street
                House Party host or Chatterbox participant and you&apos;ve received a free Party or Chat Pack with some
                great things to try.
              </p>
            </li>
            <li style={styles.listNumericItem}>
              <p>
                <strong>Trademarks and Intellectual Property</strong>
              </p>
              <p>
                Any trademarks, logos, materials and other proprietary information that Ripple Street may provide to
                you, including those of its clients, or which you have access to, may not be used without the prior
                written permission of Ripple Street or its Client and can only be used in accordance with provided
                guidelines. If you have any doubt as to what is proprietary, contact Ripple Street at {legalEmailLink} or do
                not post the information.
              </p>
            </li>
            <li style={styles.listNumericItem}>
              <p>
                <strong>You could be liable.</strong>
              </p>
              <p>
                The statements you make are at your own risk. Outside parties can pursue legal action against you for
                statements or postings that you make so be careful.
              </p>
            </li>
            <li style={styles.listNumericItem}>
              <p>
                <strong>General Guidelines.</strong>
              </p>
              <ul style={styles.listNumeric}>
                <li>
                  Do Not Reveal Non-Public Information. For example, don&apos;t share your phone number, address or
                  social security number.
                </li>
                <li>
                  Protect Yourself &ndash; Be careful about what you write and remember it will be stored and
                  retrievable.
                </li>
                <li>
                  Be Respectful. Do not be offensive or write with intent to tell lies or spread rumors. Do not use
                  ethnic or racial slurs, insults, obscenities or offensive language. Please show proper consideration
                  for the privacy of others and proper judgment regarding topics that may be considered objectionable or
                  inflammatory such as religion or politics.
                </li>
                <li>
                  Be Accurate and Constructive. Your comments may impact Ripple Street and our clients. Your postings,
                  views and comments should be expressions of your actual experience and beliefs.
                </li>
                <li>
                  Safety. Do not post any comments or content that in any way promotes unsafe activities, illegal
                  activities or products that could lead to an unsafe situation.
                </li>
                <li>
                  Remember Your Audience. If you&apos;re discussing an adult-focused event, please don&apos;t engage a
                  younger audience or allow minors to post comments.
                </li>
              </ul>
            </li>
            <li style={styles.listNumericItem}>
              <p>
                <strong>Ripple Street Pact</strong>
              </p>
              <p>
                Being selected as a House Party host, Virtual House Party host and Chatterbox™
                are special opportunities, and with being selected come certain commitments.
                Please confirm that as a House Party host, Virtual House Party host and/or Chatterbox™ you will:
              </p>
              <ul style={styles.listNumeric}>
                <li>
                  Submit only one application per household (per party)
                </li>
                <li>
                  Answer all questions accurately
                </li>
                <li>
                  For House Party and Virtual House Party hosts: Plan and host the best party you can
                </li>
                <li>
                  Share your Party Pack or Chat Pack (as well as any samples and/or coupons) with your guests and friends, as intended
                </li>
                <li>
                  Adhere to the Ripple Street Pact and specifically not sell anything in your Party Pack/Chat Pack or try to obtain additional Packs
                </li>
                <li>
                  Participate in the House Party, Virtual House Party or Chatterbox™ activities,
                  such as submitting a product review and sharing your opinions with others, as directed by Ripple Street
                </li>
                <li>
                  Comply with the Federal Trade Commission&#39;s Endorsement Guides, .com Disclosures guidelines
                  and Ripple Street Terms of Service that require event participants to properly disclose in all produced content
                  that they have received products complimentarily from Ripple Street for review and testing purposes.
                </li>
                <li>
                  Use the “#sponsored” tag in all content you produce related to your participation in this event.
                </li>
                <li>
                  You agree to conduct yourself in the spirit of Ripple Street — sharing a product with the people you love,
                  through an exclusive experience. Those selected as House Party hosts, Virtual House Party hosts and Chatterbox™
                  who break this Party Pact and abuse this trust will lose their Ripple Street privileges.
                </li>
                <li>
                  Agree to accept related Ripple Street email communications about events to which you apply and/or participate.
                </li>
              </ul>
            </li>
          </ol>
          <p>
            <strong>Brand Community Waiver</strong>
          </p>
          <p>
            In consideration of House Party, Inc. d/b/a Ripple
            Street (&quot;HPI&quot;) allowing me to participate in HPI community activities
            including
            allowing me to participate as a host and/or attend a registered House Party event, (“House Party Event”),
            including, without limitation, participating in House Party Event activities, such as product demonstrations and
            sampling, and educational and informational activities (collectively, the “Activities”), for HPI’s
            client, sponsor (“Client”) I hereby agree as follows:
          </p>
          <p>I represent that: (1) I am eighteen (18) years of age or older. In cases of Ripple Street Events with restricted
            participation of adults aged 21+ only, I represent that: (1) I am twenty-one (21) years of age or older.
            I agree that as consideration for being permitted to participate in the
            community and/or host and/or participate in any of the Activities, I, on behalf of myself and my children and
            minors for whom I am a legal guardian, hereby grant HPI and its designees (including, without limitation, Client
            and its designees) and their respective affiliates, licensees, permitees, successors and assigns, and each of
            them, an unrestricted, absolute, universal, perpetual, irrevocable, non-royalty bearing, and transferable right
            and license (but not any obligation) to use, copy, transmit, distribute, display, modify, perform, present,
            publish, transform, create works and derivative works, and otherwise promote or utilize my name, image, likeness,
            voice, words and/or other personal attribute(s) or other personal information, and those of my children and minors
            for whom I am a legal guardian (collectively, “Personal Attributes”), captured, photographed or otherwise recorded
            or memorialized in any manner by myself or any other person in connection with any of the Activities, in any
            medium or format whether now or hereafter existing (including, without limitation, print, direct mail, online
            (including the HPI Facebook page as well as those of its Clients), mobile or wireless communications, radio or
            television broadcast, telecast or photograph), for any purpose whatsoever (including, without limitation, in
            connection with the creation, advertising, sale and/or promotion of any products and/or services), and without any
            consideration or notice to or consent by me or any third party. I, on behalf of myself and my children and minors
            for whom I am a legal guardian, hereby forever and irrevocably waive any rights any of us may have in or to any of
            the foregoing, and I understand and agree that HPI and its designees (including, without limitation, Client and
            its designees) are the exclusive owners (to the extent the materials are created by or at the direction of each
            such party) of any and all right, title and interest, including copyright, in and to any materials of any kind or
            nature containing or developed from use of our respective Personal Attributes. Without limiting the foregoing, I
            understand and agree that such materials may be used in whole or in part, individually or in conjunction with
            other photographs or images, and neither I, my children nor minors for whom I am a legal guardian shall have any
            right of approval or notice, any claim to any compensation, or any claim arising out of the use, alteration,
            distortion or illusionary effect or use in any composite form of any of our respective Personal Attributes.
          </p>
          <p>I understand that the information I have given to HPI online (including, without limitation, in connection with
            the host and/or guest registration and RSVP process as well as the addition of any information to the community)
            may be used to provide me with additional information about Client. I also agree that Ripple Street may use and
            share my personal information as described in the Ripple Street {privacyPolicyLink}.
          </p>
          <p>I acknowledge that I have read and understand the HPI disclosure guidelines regarding my postings on the
            community and/or party Microsite as well as other social media platforms. I understand that I must follow all
            disclosure guidelines. In the event that I do not make proper disclosures, I understand that I may not be allowed
            to participate in future House Party Events.
          </p>
          <p>I, on behalf of myself, my children and minors for whom I am a legal guardian, and anyone who obtains any rights
            from or through any of us, hereby forever and irrevocably release and discharge HPI and Client; their respective
            parents, subsidiaries, affiliates, partners, members, managers, agents, licensees, designees, insurers, personal
            and legal representatives, successors and assigns; House Party Event hosts; other participants in the Activities;
            and any director, officer, employee or agent of any of the foregoing (each considered one of the “Releasees”
            herein) from any and all liability, claims, demands, losses, damages, costs or expenses (including, without
            limitation, attorneys’ fees and costs) (collectively, “Losses”) arising out of or in any way related to the
            hosting of, or participation in or attendance at the Activities, by myself or my children or minors for whom I am
            a legal guardian, including, but not limited to, Losses (including, without limitation, Losses from BODILY INJURY,
            ILLNESS OR DEATH) caused or alleged to be CAUSED IN WHOLE OR IN PART BY (i) THE NEGLIGENCE OR MISCONDUCT of any
            Releasee or otherwise, including negligent rescue operations, (ii) any claim, action, suit or demand brought by
            any third party against any Releasee by reason of or in connection with the hosting of, or participation in or
            attendance at the Activities, by myself or my children or minors for whom I am a legal guardian, or (iii) invasion
            of privacy, right of publicity, defamation, libel, slander, copyright infringement, trademark infringement, or any
            other causes of action arising out of the use of the Personal Attributes of myself, my children or minors for whom
            I am a legal guardian. I further covenant not to sue any Releasee or cause any Releasee to be sued regarding any
            matter released above. I represent that I understand the nature of the Activities, and I ASSUME ALL RISKS
            associated with the hosting of, participation in or attendance at the activities, by myself, and my children and
            minors for whom I am a legal guardian.
          </p>
          <p>I have read this Release, Waiver of Liability and Indemnity Agreement (this “Release”), understand that I have
            given up substantial rights by signing it and have signed it freely and without any inducement or assurance of any
            nature and intend it be a complete and unconditional release of all liability to the greatest extent allowed by
            law. I, on behalf of myself, and my children and minors for whom I am a legal guardian, hereby forever and
            irrevocably waive any and all rights to seek or obtain any injunctive or other equitable relief with respect to
            any matter within the scope of this Release, or to rescind, limit or disaffirm this Release. I further agree to
            indemnify and hold harmless each Releasee from and against any Loss regarding any matter within the scope of this
            Release. If any provision of this Release is unenforceable, it shall be modified to the extent reasonably
            necessary to make the provision legal, valid and binding, and the remainder of this Release shall remain
            enforceable to the full extent allowed by law. No statements regarding the effect of this Release, not contained
            in this Release, shall modify the terms of the Release. In any proceeding or other attempt to enforce, construe or
            to determine the validity of this Release, the nonprevailing party will pay the reasonable expenses of the
            prevailing party, including, without limitation, reasonable attorneys’ fees and costs. This Release shall be
            binding upon myself, my children and minors for whom I am a legal guardian, and our respective successors,
            assignees, subrogors, heirs, next of kin, legal and personal representatives, and anyone who obtains any rights
            from or through any of us.
          </p>
          <p>
            <strong>Host Agreement &amp; Waiver of Liability</strong>
          </p>
          <p>
            In consideration of House Party, Inc. d/b/a Ripple
            Street (&quot;Ripple Street&quot;) allowing me to host
            and/or attend a registered Ripple Street event, (&quot;Ripple Street Event&quot;),
            including, without limitation, participating in Ripple Street Event activities,
            such as product demonstrations and sampling, and educational and informational
            activities (collectively, the “Activities”), for Ripple Street’s Client Sponsor (“Client”)
            I hereby agree as follows:
          </p>

          <p>
            I represent that: (1) I am eighteen (18) years of age or older; (2) I have never been convicted of or charged
            with any crime of a sexual nature, including but not limited to, forcible rape, statutory rape,
            sexual assault or sexual abuse of a minor.
          </p>

          <p>
            In cases of Ripple Street Events with restricted participation of adults aged 21+ only, I represent that:
            (1) I am twenty-one (21) years of age or older;
            (2) I will invite to, and allow to attend, the Ripple Street Event only individuals twenty-one (21) years of age or older;
            (3) the information I have given to Ripple Street online (including, without limitation,
            in connection with the host and/or guest registration and RSVP process) is accurate;
            (4) I will provide proof of my age by providing Ripple Street with a photocopy of my current,
            valid driver’s license and hereby authorize Ripple Street to verify (directly or through the use of third parties,
            including the use of third party databases that contain driver’s license,
            financial and other personally identifiable information) my age,
            identity and other personally identifiable information pertinent to my participation in the Activities;
            (5) I have never been convicted of or charged with any criminal offense,
            or been issued a citation, arising out of any alcohol-related activity, including, but not limited to,
            driving under the influence of alcohol, public intoxication, or underage consumption of alcohol;
            (6) I have never been convicted of or charged with any crime of a sexual nature,
            including but not limited to, forcible rape, statutory rape, sexual assault or sexual abuse of a minor; and
            (7) I am not an owner, employee, or member of the immediate household or family of an owner or employee,
            of a retail alcohol beverage licensee or other alcohol beverage supplier or wholesaler.
            I understand and agree that alcohol may be served during the Activities, and that my decision to serve and/or
            consume any alcohol is my own decision for which I shall be solely responsible.
            I further understand and agree that neither Ripple Street nor Client promotes or condones the
            irresponsible consumption of alcohol or providing alcohol to minors. I will adhere to all applicable laws,
            rules and regulations regarding the provision of alcohol and/or the presence of alcohol near minors.
            Should I choose to have alcohol present at the Activities, I agree that (i) food will also be served,
            (ii) each participant will be limited to a maximum of two drinks,
            (iii) I will provide cab vouchers for participants who may become impaired during the Activities.
          </p>

          <p>
            I agree that as consideration for being permitted to host any of the Activities,
            I hereby grant Ripple Street and its designees (including, without limitation, Client and its designees)
            and their respective affiliates, licensees, permitees, successors and assigns, and each of them,
            an unrestricted, absolute, universal, perpetual, irrevocable, non-royalty bearing, and transferable right and license
            (but not any obligation) to use, copy, transmit, distribute, display, modify, perform, present, publish, transform,
            create works and derivative works, and otherwise promote or utilize my name, image, likeness, voice,
            words and/or other personal attribute(s) or other personal information, (collectively, “Personal Attributes”),
            captured, photographed or otherwise recorded or memorialized in any manner by myself or any other person in
            connection with any of the Activities, in any medium or format whether now or hereafter existing (including,
            without limitation, print, direct mail, online (including the Ripple Street Facebook page as well as its Clients),
            mobile or wireless communications, radio or television broadcast, telecast or photograph), for any purpose whatsoever
            (including, without limitation, in connection with the creation, advertising, sale and/or promotion of any products
            and/or services), and without any consideration or notice to or consent by me or any third party.
            I hereby forever and irrevocably waive any rights I may have in or to any of the foregoing, and I understand and agree
            that Ripple Street and its designees (including, without limitation, Client and its designees) are the exclusive owners
            (to the extent the materials are created by or at the direction of each such party) of any and all right, title and interest,
            including copyright, in and to any materials of any kind or nature containing or developed from use of our respective
            Personal Attributes. Without limiting the foregoing, I understand and agree that such materials may be used in whole or in part,
            individually or in conjunction with other photographs or images, and I, shall have no right of approval or notice,
            any claim to any compensation, or any claim arising out of the use, alteration, distortion or illusionary effect or
            use in any composite form of any of our respective Personal Attributes. I understand that the information I have given
            to Ripple Street online (including, without limitation, in connection with the host and/or guest registration and RSVP process)
            may be used to provide me with additional information about Client.
            I also agree that Ripple Street may use and share my personal information as described in the Ripple Street {privacyPolicyLink}.
          </p>

          <p>
            I hereby forever and irrevocably release and discharge Ripple Street and Client; their respective parents, subsidiaries,
            affiliates, partners, members, managers, agents, licensees, designees, insurers, personal and legal representatives,
            successors and assigns; Ripple Street Event hosts; other participants in the Activities; and any director, officer,
            employee or agent of any of the foregoing (each considered one of the “Releasees” herein) from any and all liability,
            claims, demands, losses, damages, costs or expenses (including, without limitation, attorneys’ fees and costs)
            (collectively, “Losses”) arising out of or in any way related to my hosting of, or participation in or attendance at
            the Activities, including, but not limited to, Losses (including, without limitation, Losses from BODILY INJURY, ILLNESS OR DEATH)
            caused or alleged to be CAUSED IN WHOLE OR IN PART BY (i) THE NEGLIGENCE OR MISCONDUCT of any Releasee or otherwise,
            including negligent rescue operations, (ii) any claim, action, suit or demand brought by any third party against
            any Releasee by reason of or in connection with my hosting of, or participation in or attendance at the Activities,
            whether or not such Loss arises out of the use of the Client’s products, or (iii) invasion of privacy, right of publicity,
            defamation, libel, slander, copyright infringement, trademark infringement, or any other causes of action arising out of
            the use of my Personal Attributes. I further covenant not to sue any Releasee or cause any Releasee to be sued regarding
            any matter released above. I represent that I understand the nature of the Activities, and I ASSUME ALL RISKS associated
            with my hosting of, participation in or attendance at the activities. I ALSO ASSUME ALL RISKS associated with and on
            behalf of the guests attending my event and their participation at the activities.
          </p>

          <p>
            I have read this Release and Waiver of Liability Agreement (this “Release”), understand that I have given up substantial
            rights by signing it and have signed it freely and without any inducement or assurance of any nature and intend
            it be a complete and unconditional release of all liability to the greatest extent allowed by law.
            I hereby forever and irrevocably waive any and all rights to seek or obtain any injunctive or other equitable relief
            with respect to any matter within the scope of this Release, or to rescind, limit or disaffirm this Release.
            I further agree to hold harmless each Releasee from and against any Loss regarding any matter within the scope
            of this Release whether or not such Loss arises out of the use of the Client’s products. If any provision of this
            Release is unenforceable, it shall be modified to the extent reasonably necessary to make the provision legal,
            valid and binding, and the remainder of this Release shall remain enforceable to the full extent allowed by law.
            No statements regarding the effect of this Release, not contained in this Release, shall modify the terms of the Release.
            This Release shall be binding upon me and my guests attending my Ripple Street event , my successors, assignees, heirs,
            next of kin, legal and personal representatives, and anyone who obtains any rights from or through any of us.
          </p>

          <p>
            <strong>Intellectual Property</strong>
          </p>
          <p>
            <strong>In General.</strong> Ripple Street and its licensors (our Registered Users are the licensors of the
            User Generated Content) own and reserve all rights, title and interests in this Website, including all of
            the software and code that comprise and operate this Website, and all of the text, photographs, images,
            illustrations, graphics, designs, sounds, video and audio-video clips, files and other content posted on,
            transmitted through or otherwise made available on or through this Website (the &ldquo;Content&rdquo;). This
            Website and its Content are protected under U.S. and international trademark, service mark, trade dress,
            copyright, patent, trade secret and other intellectual property laws and treaties. No right, title or
            interest in this Website or its Content are transferred to you under these Terms of Service.
          </p>
          <p>
            <strong>Copyright.</strong> Ripple Street and its licensors own and reserve the copyrights in this Website
            and its Content. The entire Content of this Website, as a whole, and each party page, as a whole, is
            copyrighted as a collective work under U.S. and international copyright laws and treaties, and Ripple Street
            owns the copyright to the selection, coordination, arrangement and enhancement of the Content of this
            Website and each party page.
          </p>
          <p>
            <strong>Copyright License.</strong> We hereby grant you a limited license to access and use this Website and
            any portion of the Content to which you have properly gained access, but only for your own personal,
            non-commercial use (unless the Content is your User Generated Content), and only if you do not remove,
            modify or obscure any copyright, trademark, or other proprietary notices from such Content (unless the
            Content is your User Generated Content). The foregoing license is subject to these Terms of Service and does
            not include use of any data mining, robots (&lsquo;bots&rsquo;) or similar data gathering or extraction
            methods. This license is revocable at any time without notice and with or without cause. You agree not to
            use, display, reproduce, retransmit, modify, distribute, disseminate, sell, publish, broadcast, circulate,
            display or in any way exploit any Content, in whole or in part, by any means, for any purpose other than for
            your personal, non-commercial use as set forth herein.
          </p>
          <p>
            <strong>Trademarks.</strong> All tradenames, trademarks and service marks displayed on this Website are the
            registered or unregistered trademarks of Ripple Street or its licensors, Sponsors, or other third parties
            (collectively, the&ldquo;Trademarks&rdquo;) and are protected by U.S. and international trademark laws and
            treaties. You may not use any Trademarks displayed on this Website without the prior express written
            permission of Ripple Street or the trademark owner.
          </p>
          <p>
            <strong>Links to Third-Party Sites</strong>
          </p>
          <p>
            This Website contains links to other websites operated by third parties, including our Sponsors, Amazon.com
            and others. Because we have no control over third-party websites, you acknowledge and agree that we are not
            responsible for the availability of such websites and do not endorse and are not responsible or liable for
            any content, advertising, services, products, or other materials on or available from such websites. You
            also acknowledge and agree that Ripple Street shall not be responsible or liable, directly or indirectly,
            for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any
            content, advertising, services, products, or other materials on or available from such websites. These Terms
            of Service do not apply to your use of third-party websites; your use of such websites is subject to the
            terms and policies of the owner of such websites.
          </p>
          <p>
            <strong>DISCLAIMER OF WARRANTIES</strong>
          </p>
          <p>
            YOU ACKNOWLEDGE AND AGREE THAT YOUR USE OF THIS WEBSITE AND ITS CONTENT AND YOUR PARTICIPATION IN RIPPLE
            STREET EVENTS IS AT YOUR SOLE RISK. RIPPLE STREET MAKES NO REPRESENTATIONS OR WARRANTIES WHATSOEVER WITH
            RESPECT TO THIS WEBSITE, ANY CONTENT ON THIS WEBSITE, ANY PRODUCT OR SERVICE PROMOTED THROUGH THIS WEBSITE,
            OR ANY RIPPLE STREET EVENT. THIS WEBSITE AND ALL OF ITS CONTENT (INCLUDING ALL USER GENERATED CONTENT) ARE
            PROVIDED &ldquo;AS IS&rdquo; AND ON AN &ldquo;AS AVAILABLE&rdquo; BASIS. TO THE FULLEST EXTENT PERMITTED BY
            APPLICABLE LAW, RIPPLE STREET DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, ARISING BY STATUTE, CUSTOMER,
            COURSE OF DEALING, COURSE OF PERFORMANCE OR IN ANY OTHER WAY, INCLUDING WITHOUT LIMITATION IMPLIED
            WARRANTIES OF TITLE, NON-INFRINGEMENT, MERCHANTABILITY, QUALITY AND FITNESS FOR A PARTICULAR PURPOSE, WITH
            RESPECT TO THIS WEBSITE, ITS CONTENT, ANY PRODUCT OR SERVICE PROMOTED THROUGH THIS WEBSITE, OR ANY RIPPLE
            STREET EVENT. WITHOUT LIMITING THE GENERALITY OF THE FOREGOING, WE DO NOT REPRESENT OR WARRANT THAT THIS
            WEBSITE, OUR SERVERS, OR ANY TRANSMISSIONS SENT FROM US OR THROUGH THIS WEBSITE WILL BE FREE OF ANY HARMFUL
            COMPONENTS (INCLUDING VIRUSES); WE DO NOT PROVIDE ANY REPRESENTATIONS OR WARRANTIES AGAINST THE POSSIBILITY
            OF DELETION, MISDELIVERY OR FAILURE TO STORE COMMUNICATIONS, PERSONALIZED SETTINGS, OR OTHER DATA; AND WE DO
            NOT REPRESENT OR WARRANT CONTINUOUS, UNINTERRUPTED OR SECURE ACCESS TO OR USE OF THIS WEBSITE. THE OPERATION
            OF THIS WEBSITE MAY BE INTERFERED WITH BY NUMEROUS FACTORS OUTSIDE OF OUR CONTROL. RIPPLE STREET DOES NOT
            MAKE ANY REPRESENTATIONS OR WARRANTIES AS TO THE ACCURACY, CORRECTNESS, COMPLETENESS OR USEFULNESS OF ANY
            CONTENT APPEARING ON THIS WEBSITE AND IS NOT RESPONSIBLE FOR ANY ERRORS OR OMISSIONS IN ANY CONTENT
            APPEARING ON THIS WEBSITE OR GENERALLY FOR THE ACCURACY, RELIABILITY, OR QUALITY OF ANY CONTENT APPEARING ON
            THIS WEBSITE. RIPPLE STREET DOES NOT ENDORSE ANY OPINION, ADVICE, COMMENT OR STATEMENT MADE ON THIS WEBSITE
            BY REGISTERED USERS, AND USER GENERATED CONTENT DOES NOT IN ANY WAY REFLECT THE OPINION, ADVICE OR STATEMENT
            OF RIPPLE STREET.
          </p>
          <p>
            Nothing in these Terms of Service will affect any statutory rights to which you may be entitled as a
            consumer to the extent your ability to alter or waive such rights by contract is limited by applicable law.
          </p>
          <p>
            <strong>LIMITATION OF LIABILITY</strong>
          </p>
          <p>
            RIPPLE STREET IS NOT RESPONSIBLE OR LIABLE IN ANY MANNER FOR ANY USER GENERATED CONTENT. ALTHOUGH WE INCLUDE
            STRICT PROVISIONS REGARDING USER GENERATED CONTENT IN THESE TERMS OF SERVICE, WE DO NOT CONTROL AND ARE NOT
            RESPONSIBLE FOR WHAT REGISTERED USERS POST ON OR THROUGH OUR WEBSITE AND ARE NOT RESPONSIBLE FOR ANY
            OFFENSIVE, INAPPROPRIATE, OBSCENE, UNLAWFUL, INFRINGING OR OTHERWISE OBJECTIONABLE OR ILLEGAL USER CONTENT
            YOU MAY ENCOUNTER ON THIS WEBSITE OR IN CONNECTION WITH YOUR USE OF THIS WEBSITE. WE ARE NOT RESPONSIBLE FOR
            THE CONDUCT, WHETHER ONLINE OR OFFLINE, OF ANY REGISTERED USER, INCLUDING HOSTS AND PARTYGOERS.
          </p>
          <p>
            UNDER NO CIRCUMSTANCES, SHALL RIPPLE STREET, OR ANY OF ITS SPONSORS, VENDORS, LICENSORS, OR SERVICE
            PROVIDERS, OR ANY OF ITS OR THEIR RESPECTIVE DIRECTORS, OFFICERS, EMPLOYEES OR AGENTS (COLLECTIVELY,
            THE &ldquo;RELEASED PARTIES&rdquo;), BE LIABLE TO YOU OR ANY THIRD PARTY CLAIMING THROUGH YOU FOR ANY LOSSES
            OR DAMAGES ARISING OUT OF OR IN CONNECTION WITH THIS WEBSITE, ITS CONTENT (INCLUDING USER GENERATED
            CONTENT), RIPPLE STREET EVENTS, OR THE CONDUCT OF ANY PARTY HOST, GUEST OR OTHER THIRD PARTY. UNDER NO
            CIRCUMSTANCES, SHALL RIPPLE STREET ITS DIRECTORS, OFFICERS, EMPLOYEES OR AGENTS, HAVE ANY LIABILITY TO YOU
            ARISING OUT OF OR IN CONNECTION WITH THE PRODUCTS AND SERVICES OF OUR SPONSORS NOR THEIR ACTIONS OR FAILURE
            TO ACT.
          </p>
          <p>
            THIS IS A COMPREHENSIVE LIMITATION OF LIABILITY THAT APPLIES TO ALL LOSSES AND DAMAGES OF ANY KIND (WHETHER
            DIRECT, INDIRECT, GENERAL, SPECIAL, CONSEQUENTIAL, INCIDENTAL, EXEMPLARY OR OTHERWISE, INCLUDING, WITHOUT
            LIMITATION, LOSS OF DATA, INCOME OR PROFITS), WHETHER THE CLAIM IS BASED ON CONTRACT, TORT (INCLUDING
            NEGLIGENCE), STRICT LIABILITY OR ANY OTHER LEGAL THEORY, EVEN IF AN AUTHORIZED REPRESENTATIVE OF RIPPLE
            STREET OR ANOTHER RELEASED PARTY HAS BEEN ADVISED OF OR SHOULD HAVE KNOWN OF THE POSSIBILITY OF SUCH
            DAMAGES, AND WITHOUT REGARD TO THE EFFECTIVENESS OF OTHER REMEDIES.
          </p>
          <p>
            IF ANY PART OF THIS LIMITATION ON LIABILITY IS FOUND TO BE INVALID OR UNENFORCEABLE FOR ANY REASON, THEN THE
            AGGREGATE LIABILITY OF THE RELEASED PARTIES FOR LIABILITIES THAT OTHERWISE WOULD HAVE BEEN LIMITED SHALL NOT
            EXCEED TEN DOLLARS ($10.00).
          </p>
          <p>
            Some jurisdictions do not allow the exclusion of liability for certain types of losses or damages.
            Accordingly, some of the foregoing limitations of liability may not apply to you. Nothing in these Terms of
            Service will limit or exclude liability for losses or damages which may not be lawfully excluded or limited
            by applicable law.
          </p>
          <p>
            <strong>Indemnification</strong> You agree to defend, indemnify and hold Ripple Street and its directors,
            officers, employees and agents harmless from and against any claims, demands, losses, liabilities, damages,
            costs or expenses (including reasonable attorneys&apos; fees and costs of suit) to the extent arising out of
            or in connection with your use of this Website or its Content in violation of these Terms of Service or your
            breach of these Terms of Service or any warranty or representation set forth herein.
          </p>
          <p>
            <strong>Dealings With Third Parties</strong> Your business dealings with any third party (including orders
            you may place through the store on this Website and your dealings with Sponsors) and any terms, conditions,
            representations or warranties associated with such dealings, are solely between you and such third party.
            You agree that Ripple Street shall not be responsible or liable for any loss, damage, or other matters of
            any sort incurred as the result of such dealings.
          </p>
          <p>
            <strong>Commercial Use</strong> You acknowledge and agree that this Website is for the personal use of
            Registered Users and other visitors only and may not be used by you directly or indirectly in connection
            with any commercial endeavors.
          </p>
          <p>
            <strong>Modification and Discontinuation</strong> We reserve the right at any time, with no liability to you
            or any third party claiming through you, to modify, edit, delete, suspend or discontinue, temporarily or
            permanently this Website (or any portion thereof), or any Ripple Street event or promotion featured on this
            Website, with or without notice.
          </p>
          <p>
            <strong>No Agency</strong> No agency, partnership, joint venture, employer-employee or franchiser-franchisee
            relationship is intended or created between you and Ripple Street by these Terms of Service.
          </p>
          <p>
            <strong>Notices</strong>
          </p>
          <p>
            You agree that Ripple Street may provide notices to you regarding changes to these Terms of Service, your
            User Generated Content, or other matters related to this Website, any Ripple Street events, or the business
            of Ripple Street, by email, regular mail, or posting on this Website.
          </p>
          <p>
            <strong>Governing Law; Venue</strong>
          </p>
          <p>
            You acknowledge and agree that these Terms of Service shall be governed by and construed in accordance with
            the internal laws of the State of New York, excluding conflict of laws provisions thereof that would
            indicate the application of the laws of any other jurisdiction and you hereby submit to exclusive
            jurisdiction in the federal and state courts of New York. You agree to receive service of process through
            certified mail or by other means sanctioned by law, and you expressly waive any claim of improper venue and
            any claim that such courts are an inconvenient forum. If the courts of the country in which you reside
            should determine that the provisions of this paragraph are not enforceable, then you agree to submit to
            binding arbitration.
          </p>
          <p>
            <strong>General</strong>
          </p>
          <p>
            As used in these Terms of Service, the term &ldquo;including&rdquo; means &ldquo;including, but not limited
            to.&rdquo; If any provision of these Terms of Service is held to be invalid or unenforceable, such
            invalidity will not affect the validity of the remaining portions, and the parties will substitute for the
            invalid provision a provision which most closely approximates the intent and economic effect of the invalid
            provision. You agree that these Terms of Service (and any license granted hereunder) may be assigned by
            Ripple Street, in its sole discretion, to a third party without notice to you. Section headings are for
            reference purposes only and in no way define, limit, construe or describe the scope or extent of such
            section. Our failure to act with respect to a breach by you or others does not waive our right to act with
            respect to subsequent or similar breaches. These Terms of Service (including our {privacyPolicyLink}, which
            is incorporated herein, and any click-through agreements, such as the Release, to which you may have agreed)
            set forth the entire understanding and agreement between us with respect to the subject matter hereof. The
            provisions of these Terms of Service will survive termination or expiration to the extent necessary to carry
            out the intentions of the parties. Without limiting the generality of the foregoing, all disclaimers of
            warranties and limitations on liability will survive the termination or expiration of these Terms of
            Service.
          </p>
          <p>
            <strong>Use of This Website Outside the United States</strong>
          </p>
          <p>
            Access to, or use of, this Website may be prohibited by law in certain countries or jurisdictions. You are
            responsible for compliance with any applicable laws of the country from which you are accessing this
            Website.
          </p>
          <p>
            <strong>Contact Us</strong>
          </p>
          <p>
            If you have any questions or concerns regarding this Website, please contact us by e-mail
            at {legalEmailLink}.
          </p>
        </div>
      </div>

    );
  }
}
